<template>
  <!--<mapObj :ueberschrift="'Hydranten'" :mapObj="'hydrant'"/>-->
  <mapObjNeu :ueberschrift="'Hydranten'" :mapObj="'hydrant'" :berechtigungen="this.$props.berechtigungen"/>
</template>

<script>
import mapObjNeu from "@/components/mapObjNeu.vue";

export default {
  name: "HydrantenView",
  components: {
    mapObjNeu
  },
  props: {
    berechtigungen: Array
  },
  data() {

  },
  methods: {
    
  },
  async created() {
    
  },
  onMounted() {

  },
  setup() {
    
  }
}
</script>